import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-120 text-center" style={{ minHeight: "80vh" }}>
      <div className="container">

        {/* IMAGE */}
        <img
          src={"assets/images/thumbs/404.png"}
          alt="404 Not Found"
          style={{
            width: "260px",
            maxWidth: "80%",
            margin: "0 auto 30px",
            display: "block",
          }}
        />

        {/* TITLE */}
        <h1 className="fw-bold text-3xl mb-3" style={{ fontSize: "2.5rem" }}>
          Oops! Page Not Found
        </h1>

        {/* SUBTEXT */}
        <p className="text-gray-600 mb-4" style={{ fontSize: "1.1rem" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* BUTTONS */}
        <div className="mt-4 d-flex justify-content-center gap-3">
          <Link
            to="/"
            className="btn btn-main rounded-pill px-32 py-12"
          >
            Go Home
          </Link>

          <Link
            to="/shop"
            className="btn btn-outline-main rounded-pill px-32 py-12"
          >
            Browse Shop
          </Link>
        </div>

      </div>
    </section>
  );
}
